import React from 'react';
import './LegalPages.css';

const Privacy = () => {
  return (
    <div className="legal-page">
      <section className="legal-header">
        <div className="legal-header-content">
          <h1>Privacy Policy</h1>
          <p className="subtitle">DocuAIHub Privacy Policy</p>
          <p className="description">
            We care about your privacy! Our Privacy Policy covers how we collect, use, disclose, 
            transfer, and store your information.
          </p>
        </div>
      </section>

      <section className="legal-content">
        <div className="content-wrapper">
          <aside className="table-of-contents">
            <h3>Table of Contents</h3>
            <ul>
              <li><a href="#collection-use">Collection and Use of Personal Data</a></li>
              <li><a href="#personal-info-collect">What personal information we collect</a></li>
              <li><a href="#personal-info-use">How we use your personal information</a></li>
              <li><a href="#data-access">Data Access, Edit, and Deletion</a></li>
              <li><a href="#ssl-encryption">SSL Encryption</a></li>
              <li><a href="#cookies">Cookies and Tracking</a></li>
            </ul>
          </aside>

          <main className="main-content">
            <section id="collection-use" className="content-section">
              <h2>Collection and Use of Personal Data</h2>
              <p>
                At DocuAIHub, we are committed to protecting your privacy and ensuring the security 
                of your personal information. This Privacy Policy explains what data we collect, 
                how we use it, and your rights regarding your personal information.
              </p>
              <p>
                We collect information that you provide directly to us when you create an account, 
                use our services, or communicate with us. This may include your name, email address, 
                payment information, and documents you upload for processing.
              </p>
            </section>

            <section id="personal-info-collect" className="content-section">
              <h2>What Personal Information We Collect</h2>
              <ul>
                <li><strong>Account Information:</strong> Name, email address, password</li>
                <li><strong>Payment Information:</strong> Credit card details, billing address (processed securely through our payment provider)</li>
                <li><strong>Usage Data:</strong> Information about how you use our services, including features accessed and documents processed</li>
                <li><strong>Technical Data:</strong> IP address, browser type, device information</li>
                <li><strong>Document Data:</strong> Files you upload for processing (temporarily stored and processed)</li>
              </ul>
            </section>

            <section id="personal-info-use" className="content-section">
              <h2>How We Use Your Personal Information</h2>
              <p>We use the information we collect for the following purposes:</p>
              <ul>
                <li>To provide, maintain, and improve our services</li>
                <li>To process your transactions and send related information</li>
                <li>To send you technical notices, updates, and support messages</li>
                <li>To respond to your comments, questions, and customer service requests</li>
                <li>To monitor and analyze trends, usage, and activities</li>
                <li>To detect, prevent, and address technical issues and fraudulent activity</li>
                <li>To comply with legal obligations</li>
              </ul>
            </section>

            <section id="data-access" className="content-section">
              <h2>Data Access, Edit, and Deletion</h2>
              <p>
                You have the right to access, update, or delete your personal information at any time. 
                You can manage your account settings directly through our platform or contact our 
                support team at <a href="mailto:help@docuaihub.com">help@docuaihub.com</a>.
              </p>
              <p>
                <strong>Document Deletion:</strong> All uploaded documents are automatically deleted 
                from our servers within 24 hours of processing. You can also manually delete documents 
                immediately after processing.
              </p>
              <p>
                <strong>Account Deletion:</strong> You may request complete deletion of your account 
                and all associated data by contacting our support team.
              </p>
            </section>

            <section id="ssl-encryption" className="content-section">
              <h2>SSL Encryption and Security</h2>
              <p>
                We use industry-standard SSL/TLS encryption to protect data transmitted between your 
                device and our servers. All sensitive information is encrypted both in transit and at rest.
              </p>
              <p>
                Our infrastructure is SOC2 certified and undergoes regular security audits. We implement 
                appropriate technical and organizational measures to protect your personal information 
                against unauthorized access, alteration, disclosure, or destruction.
              </p>
            </section>

            <section id="cookies" className="content-section">
              <h2>Cookies and Tracking Technologies</h2>
              <p>
                We use cookies and similar tracking technologies to track activity on our service and 
                hold certain information. Cookies are files with small amounts of data that are sent 
                to your browser from a website and stored on your device.
              </p>
              <p>
                You can instruct your browser to refuse all cookies or indicate when a cookie is being 
                sent. However, if you do not accept cookies, you may not be able to use some portions 
                of our service.
              </p>
            </section>

            <section className="content-section">
              <h2>Contact Us</h2>
              <p>
                If you have any questions about this Privacy Policy, please contact us:
              </p>
              <ul>
                <li>Email: <a href="mailto:help@docuaihub.com">help@docuaihub.com</a></li>
                <li>Phone: +35777788373</li>
                <li>Address: 1 Maiou 3, 2610 Agios Epifanios Oreinis, Cyprus</li>
              </ul>
            </section>

            <section className="content-section">
              <p className="last-updated">Last Updated: February 2026</p>
            </section>
          </main>
        </div>
      </section>
    </div>
  );
};

export default Privacy;
